import inMap from './../../../../lib/inmap';
import {
    merge
} from './../../../../tool/util';
const config = {
    tooltip: {
        show: false,
        formatter: "{name}+'：'+{count}"
    },
    legend: {
        show: false,
    },
    style: {
        normal: {
            backgroundColor: "rgba(0,133,235,0.6)",
            borderWidth: 1,
            label: {
                show: false, // 是否显示
                font: "13px bold ",
                color: "#fff"
            }
        },
        mouseOver: {
            shadowColor: "rgba(0, 0, 0, 1)",
            shadowBlur: 10,
            borderWidth: 1,
            label: {
                color: "rgba(0, 0, 0, 1)"
            }
        },
    }
}

export default class AbstractPolygon extends inMap.PolygonOverlay {
    constructor(opts, polygonData) {
        super(merge(config, opts || {}));
        this.polygonData = JSON.parse(JSON.stringify(polygonData || []));
    }
    setPolygonData(polygonData) {
        this.polygonData = JSON.parse(JSON.stringify(polygonData));
    }
    /**
     *设置样式
     * @param {} opts 参数 
     */
    setStyle(opts) {
        opts.data = null;
        this.setOptionStyle(opts);
    }
    setSelectedByName(name) {

        const result = this.polygonData.filter((item) => {
            return item.name == name || item.name.indexOf(name) > -1;
        })
        this.setSelectedList(result);
    }
    _clearValue() {
        this.polygonData.forEach(element => {
            element.count = 0;
        });
    }
    _forEachValue(data) {
        this.polygonData.forEach(element => {
            let result = data.find((item) => {
                return item.name == element.name || element.name.indexOf(item.name) > -1;
            });
            if (result) {
                this._merge(element, result)
                // element.count = result.count;

                // element.properties = {
                //     ...element.properties,
                //     ...result
                // }
            }
        });
    }
    _merge(polygon, item) {
        polygon.count = item.count;
        polygon.style = {};
        //合并样式
        const styles = ['borderStyle', 'backgroundColor', 'opacity', 'borderWidth', 'borderColor', 'borderOpacity', 'shadowColor', 'shadowBlur'];
        for (let index = 0; index < styles.length; index++) {
            const key = styles[index];
            if (item[key] && item[key].trim() !== '') {
                polygon.style[key] = item[key];
            }
        }

        polygon.properties = {
            ...polygon.properties,
            ...item
        }

    }
    getValue() {
        return this.polygonData.map((item) => {
            return {
                name: item.name,
                count: item.count
            }
        });
    }
    /**
     * 设置围栏value值
     * @param {*} data 
     * data 数据结构
     * [
     *    {
     *      name : "",
     *      value : 1
     *     }
     * ]
     */
    setValue(data) {
        this._clearValue();
        this._forEachValue(data);
        this.setData(this.polygonData);
    }
    /**
     * 显示并设置围栏
     * @param {*} data 
     * [
     *    {
     *      name : "",
     *      value : 1
     *     }
     * ]
     */
    setShowValue(data) {
        this._clearValue();
        this._forEachValue(data);
        let filterName = [];
        this.polygonData.forEach(element => {
            let result = data.find((item) => {
                return item.name == element.name || element.name.indexOf(item.name) > -1;
            });
            if (result) {
                // element.count = result.count;
                // element.properties = {
                //     ...element.properties,
                //     ...result
                // }
                this._merge(element, result)
                filterName.push(element);
            }
        });
        this.setData(filterName);
    }
}